import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyResultLookupComponent } from './key-result-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [KeyResultLookupComponent],
  exports: [KeyResultLookupComponent]
})
export class KeyResultLookupModule { }
